/** 图片和人员必须与当前识别结果绑定。 */
export function canSubmitRefund(state: { receipt: string; memberId: string; busy: boolean }): boolean {
  return Boolean(state.receipt && state.memberId && !state.busy);
}

/** 更换任一图片后清除识别及人员选择。 */
export function invalidateRecognition<T extends { receipt: string; memberId: string }>(state: T): T {
  return { ...state, receipt: "", memberId: "" };
}
